import React, { PureComponent } from 'react';
import FooterManager from '../managers/FooterManager';
import { FacebookIcon, TwitterIcon, YoutubeIcon } from '../managers/IconManager';

class Footer extends PureComponent {
  static getSocialIcon(social) {
    switch (social) {
      case 'facebook':
        return <a href={FooterManager.getFacebookLink()}>{FacebookIcon('footer__social__icon')}</a>;
      case 'twitter':
        return <a href={FooterManager.getTwitterLink()}>{TwitterIcon('footer__social__icon')}</a>;
      case 'youtube':
        return <a href={FooterManager.getYoutubeLink()}>{YoutubeIcon('footer__social__icon')}</a>;
      default:
        console.log(`Couldn't find social media icon for: ${social}`);
        return null;
    }
  }

  render() {
    return (
      <div>
        <div className="footer footer__social">
          <div className="footer__social__stripe" />
          {this.constructor.getSocialIcon('facebook')}
          {this.constructor.getSocialIcon('twitter')}
          {this.constructor.getSocialIcon('youtube')}
          <div className="footer__social__stripe" />
        </div>
        <div className="font-paragraph footer footer__copyright">
          {FooterManager.getCopyright()}
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js